<template>
  <html>
    <head>
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
      <meta http-equiv="Content-Style-Type" content="text/css" />
      <meta name="generator" content="Aspose.Words for .NET 17.1.0.0" />
      <title />
    </head>

    <body>
      <div style="padding: 64px 148px">
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: center;
            widows: 0;
            orphans: 0;
            font-size: 22pt;
          "
        >
          <span style="font-family: '等线'; font-weight: bold">腾讯智慧医药管理平台</span>
          <span style="font-family: '等线'; font-weight: bold">服务协议</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">&#xa0;</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-indent: 21pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">欢迎您使用腾讯智慧医药管理平台服务！</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-indent: 21pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">
            为使用腾讯智慧医药管理平台服务（简称“本服务”），您应当阅读并遵守《腾讯智慧医药管理平台服务协议》（简称“
          </span>
          <span style="font-family: '等线'" />
          <span style="font-family: '等线'">
            本协议”）。请您务必审慎阅读、充分理解各条款内容，特别是限制或免除责任的条款，以及开通或使用某项服务的单独协议、规则。限制或免责条款可能以加粗或加下划线的形式提示您重点注意。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-indent: 21pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">
            除非您已阅读并接受本协议及相关协议、规则等的所有条款，否则，您无权使用本服务。一旦您选择“同意协议并提交”（具体措辞详见注册页面）并完成注册流程，或您以任何方式使用本服务，即视为您已阅读并同意上述协议、规则等的约束。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-indent: 21pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">
            您有违反本协议的任何行为时，腾讯有权依照本协议根据您违反情况随时单方采取限制、中止或终止向您提供服务等措施，并有权追究您相关责任。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">&#xa0;</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 22pt;
          "
        >
          <span style="font-family: '等线'">第一条</span>
          <span style="font-family: '等线'" />
          <span style="font-family: '等线'">通则</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">1.1</span>
          <span style="font-family: '等线'">
            本服务指为医药行业企业提供的微信公众号、小程序管理端及相关用户、医药代表的工具型管理平台，包括但不限于以下功能或服务：微信公众号、小程序的内容管理、公众号及企业运营数据管理、公众号及小程序医生用户管理、医药代表管理、企业微信的消息管理、应用管理、通讯录管理等，具体功能和服务内容请见本服务的产品简介。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">1.2</span>
          <span style="font-family: '等线'">
            本服务的种类、服务标准、使用规则、结算方式等统称“服务规则”，以您所在单位与腾讯公司签署的本服务具体商务合同为准
          </span>
          <span style="font-family: '等线'">（简称“商务合同”）；</span>
          <span style="font-family: '等线'">商务合同未约定的事项，以</span>
          <span style="font-family: '等线'">本服务对外公布的</span>
          <span style="font-family: '等线'">API</span>
          <span>
            <span style="font-family: '等线'">
              、产品使用说明等各项文档为准（简称“服务文档”）；服务文档未规定的事项，以
            </span>
            <span style="font-family: '等线'">本协议为准。</span>
            <span style="font-family: '等线'">
              如上述文件内容存在矛盾或冲突内容，具体适用效力顺序从高到低如下：（
            </span>
            <span style="font-family: '等线'">1</span>
            <span style="font-family: '等线'">）商务合同；（</span>
            <span style="font-family: '等线'">2</span>
            <span style="font-family: '等线'">）服务文档；（</span>
            <span style="font-family: '等线'">3</span>
            <span>
              <span style="font-family: '等线'">
                ）本协议。您及您所在单位均需遵守本服务的相关商务合同、服务文档及本协议。
              </span>
            </span>
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">1.3</span>
          <span style="font-family: '等线'">腾讯公司有权随时对本协议</span>
          <span style="font-family: '等线'">及服务文档</span>
          <span style="font-family: '等线'">
            进行调整，并通过网站公告、邮件通知、短信通知等方式予以公布，而无需另行获得您同意，您应在调整后尽快
          </span>
          <span style="font-family: '等线'">了解调整后的内容</span>
          <span style="font-family: '等线'">。您在调整后继续使用本服务</span>
          <span style="font-family: '等线'">的</span>
          <span style="font-family: '等线'">，</span>
          <span style="font-family: '等线'">将</span>
          <span style="font-family: '等线'">视为同意调整后的协议</span>
          <span style="font-family: '等线'">及服务文档</span>
          <span style="font-family: '等线'">内容。</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">1.4</span>
          <span style="font-family: '等线'">腾讯公司仅向您提供本服务，是中立</span>
          <span style="font-family: '等线'">的</span>
          <span style="font-family: '等线'">技术服务提供者。本服务所需的各项待</span>
          <span style="font-family: '等线'">处理、</span>
          <span style="font-family: '等线'">分析数据</span>
          <span style="font-family: '等线'">、信息、内容等均</span>
          <span style="font-family: '等线'">
            由您或您所在单位自行生成收集，由此产生的一切责任由您或您所在单位自行承担。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">&#xa0;</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 22pt;
          "
        >
          <span style="font-family: '等线'">第二条</span>
          <span style="font-family: '等线'" />
          <span style="font-family: '等线'">帐户</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">2.1</span>
          <span style="font-family: '等线'">本服务将根据您所属的机构</span>
          <span style="font-family: '等线'">（简称“企业”）</span>
          <span style="font-family: '等线'">提供的相关资料及配置方案，为您开通相关帐户。</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">2.2</span>
          <span style="font-family: '等线'">
            本协议效力适用于您名下全部帐户。本服务账号的所有权归属腾讯公司，您在服务期内享有使用权。本服务帐户将作为您使用本服务的身份识别依据，您应当对本服务帐户采取必要、有效的保密措施，并为您本服务帐户下的一切行为负
          </span>
          <span style="font-family: '等线'">责。</span>
          <span>
            <span style="font-family: '等线'">
              请妥善保管本服务的登录账号及密码信息，如发生遗失、泄露等安全事件给您或企业带来任何损失和影响，本服务不承担任何责任，且本服务不承诺可以找回遗失的账号密码或提供备用的账号密码，也不承诺在发生遗失、泄露等安全事件时您或企业不会遭受任何损失和影响。
            </span>
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">2.3</span>
          <span style="font-family: '等线'">
            若企业因自身经营需要，将其以企业名义开通的本服务帐户交由您管理
          </span>
          <span style="font-family: '等线'">、使用</span>
          <span style="font-family: '等线'">
            的，请做好权限管控，并且在遇到人员变动时及时完成内部交接和账号安全保护（比如更改登录密码等）。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">2.4</span>
          <span style="font-family: '等线'">
            您承诺对账号的管理及账号下的一切行为负责，若账号或账号下行为出现
          </span>
          <span style="font-family: '等线'">任何</span>
          <span style="font-family: '等线'">纠纷</span>
          <span style="font-family: '等线'">或问题</span>
          <span style="font-family: '等线'">时（包括但不限于实施违法违规行为、逾期支付服务费</span>
          <span style="font-family: '等线'">、侵犯第三方权益</span>
          <span style="font-family: '等线'">等），需由您或您所在单位承担全部责任。</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">2.5</span>
          <span style="font-family: '等线'">您需规范自身对本服务帐户的使用与管理</span>
          <span style="font-family: '等线'">，您将被视为代表您所在单位使用本服务</span>
          <span style="font-family: '等线'">。</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">&#xa0;</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 22pt;
          "
        >
          <span style="font-family: '等线'">第三条</span>
          <span style="font-family: '等线'" />
          <span style="font-family: '等线'">服务规则</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">3.1</span>
          <span style="font-family: '等线'">服务开通</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">本服务的开通需要您所在单位与腾讯公司签订单独的</span>
          <span style="font-family: '等线'">商务合同</span>
          <span style="font-family: '等线'">，单独的</span>
          <span style="font-family: '等线'">商务合同</span>
          <span style="font-family: '等线'">
            可能以电子文档形式展示，也可能是独立的纸质文档形式展示。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">3.2</span>
          <span style="font-family: '等线'">服务费用</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">3.2.1</span>
          <span style="font-family: '等线'">本服务结算方式、计费标准以</span>
          <span style="font-family: '等线'">商务合同</span>
          <span style="font-family: '等线'">为准。</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">3.3</span>
          <span style="font-family: '等线'">服务保障</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">3.3.1</span>
          <span style="font-family: '等线'">
            腾讯公司向您提供售后服务，协助您解答、处理使用本服务过程中遇到的问题。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">3.4</span>
          <span style="font-family: '等线'">服务中止或终止</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">3.4.1</span>
          <span style="font-family: '等线'">
            为了向您提供更加完善的服务，腾讯公司有权定期或不定期地对服务平台或相关设备进行检修、维护、升级等（统称“常规维护”），如因常规维护造成本服务在合理时间内中断或暂停的，腾讯公司无需为此向您承担任何责任。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">3.4.2</span>
          <span style="font-family: '等线'">
            为保证服务的安全性和稳定性，腾讯公司可能对您使用的机房、服务器、带宽、数据库等产品进行不定期的升级、迁移等，您应予以配合。当涉及重大变更（如机房迁移），腾讯公司应当提前通知您。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">3.4.3</span>
          <span style="font-family: '等线'">
            如本服务到期或终止，对于您因使用本服务而存储在腾讯公司服务器中的数据等任何信息，腾讯公司将根据具体产品的服务规则为您保留一定期限。您应承担保留期限内产生的费用（若有），并在保留期限届满前结清费用、完成全部数据的迁移。保留期限届满后，本服务将自动删除您的所有数据。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">3.4.4</span>
          <span style="font-family: '等线'">
            腾讯公司有权根据自身运营安排，随时调整、终止部分服务（包括但不限于对服务进行升级、整合等）。但是，腾讯公司应提前通知您，以便您做好相关数据的转移备份以及业务调整等，以保护您的合法权益。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">3.5</span>
          <span style="font-family: '等线'">第三方产品或服务</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">3.5.1</span>
          <span style="font-family: '等线'">
            如果您通过本服务获取、使用第三方提供的任何产品或服务（包括但不限于本服务服务市场中由服务商等第三方提供的产品、服务），您应当评估该产品或服务是否符合您要求。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">3.5.2</span>
          <span style="font-family: '等线'">
            第三方产品或服务的开通，可能需要您与第三方另行签订单独的服务协议，
          </span>
          <span style="font-family: '等线'">
            单独的服务协议可能以电子文档形式展示，也可能是独立的纸质文档，您可以根据自身情况决定是否接受服务协议及使用产品或服务。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">3.5.3</span>
          <span style="font-family: '等线'">
            您因使用第三方产品或服务产生的纠纷由您与第三方协商解决。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">&#xa0;</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 22pt;
          "
        >
          <span style="font-family: '等线'">第四条</span>
          <span style="font-family: '等线'" />
          <span style="font-family: '等线'">您的权利义务</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">4.1</span>
          <span style="font-family: '等线'">
            您有权依照本协议约定使用本服务服务并获得腾讯公司的技术支持和售后服务。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">4.2</span>
          <span style="font-family: '等线'">
            您在使用本服务时须遵守相关法律法规、规章制度，维护互联网秩序和安全；不得从事包括但不限于以下行为，也不得为任何违反法律法规的行为提供便利：
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">4.2.1</span>
          <span style="font-family: '等线'">
            实施危害国家安全、荣誉和利益，煽动颠覆国家政权、推翻社会主义制度，煽动分裂国家、破坏国家统一，宣扬恐怖主义、极端主义，宣扬民族仇恨、民族歧视。
          </span>
          <br />
          <span style="font-family: '等线'">4.2.2</span>
          <span style="font-family: '等线'">
            实施诈欺、虚伪不实或误导行为，或实施侵害他人知识产权等任何合法权益的行为，如“私服”、“外挂”等。
          </span>
          <br />
          <span style="font-family: '等线'">4.2.3</span>
          <span style="font-family: '等线'">发布、传播垃圾邮件（</span>
          <span style="font-family: '等线'">SPAM</span>
          <span style="font-family: '等线'">
            ）或包含危害国家秩序和安全、封建迷信、淫秽、色情、低俗等违法违规信息。
          </span>
          <br />
          <span style="font-family: '等线'">4.2.4</span>
          <span style="font-family: '等线'">
            违反与本服务网络相联通之网络、设备或服务的操作规定；实施违法或未授权之接取、盗用、干扰或监测。
          </span>
          <br />
          <span style="font-family: '等线'">4.2.5</span>
          <span style="font-family: '等线'">
            实施任何破坏或试图破坏网络安全的行为，包括但不限于以病毒、木马、恶意代码、钓鱼等方式，对网站、服务器进行恶意扫描、非法侵入系统、非法获取数据等。
          </span>
          <br />
          <span style="font-family: '等线'">4.2.6</span>
          <span style="font-family: '等线'">
            实施任何改变或试图改变本服务提供的系统配置或破坏系统安全的行为；利用技术或其他手段破坏、扰乱本服务的运营或他人对本服务的使用；以任何方式干扰或企图干扰腾讯公司任何产品或任何部分、功能的正常运行，或者制作、发布、传播上述工具、方法等。
          </span>
          <br />
          <span style="font-family: '等线'">4.2.7</span>
          <span style="font-family: '等线'">因从事包括但不限于“</span>
          <span style="font-family: '等线'">DNS</span>
          <span style="font-family: '等线'">
            解析”、“安全服务”、“域名代理”、“反向代理”等任何业务，导致您自己频繁遭受攻击（包括但不限于
          </span>
          <span style="font-family: '等线'">DDoS</span>
          <span style="font-family: '等线'">
            攻击）且未及时更正行为，或未根据腾讯公司要求消除影响，从而对本服务平台或他人产生影响的。
          </span>
          <br />
          <span style="font-family: '等线'">4.2.8</span>
          <span style="font-family: '等线'">
            实施其他违法、违规行为，包括但不限于赌博等非法活动。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">4.3</span>
          <span style="font-family: '等线'">
            您不应在本服务上安装、使用盗版软件等，并且您应按照国家有关规定对您使用的计算机信息系统采取安全保护措施，包括但不限于安装经国家许可的计算机信息系统安全专用产品等。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">4.4</span>
          <span style="font-family: '等线'">
            您通过本服务进行分析的数据中如包含任何个人信息，您应在将相关信息导入本服务前按照所适用法律法规的要求获得数据主体充分的授权同意，并采取妥善的安全保障措施，确保不会出现个人信息安全风险。因您使用本服务出现任何个人信息泄露、侵权、违规情况，应由您或您所在单位负责处理并承担由此产生的一切法律责任，且腾讯公司有权在此情况下立即暂停或终止提供本服务。腾讯公司如因此而遭受任何损失，包括但不限于政府处罚、向第三方赔偿等，有权向您或您所在单位索赔。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">4.5</span>
          <span style="font-family: '等线'">
            您应自行确保您及您所在单位导入本服务的数据信息的准确性、时效性、完整性并符合你使用本服务的目的和要求，因上述数据本身的问题导致本服务无法满足约定的要求，相关责任和损失由您及您所在单位承担，与腾讯公司无关。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">&#xa0;</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 22pt;
          "
        >
          <span style="font-family: '等线'">第五条</span>
          <span style="font-family: '等线'" />
          <span style="font-family: '等线'">腾讯公司权利义务</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">5.1</span>
          <span style="font-family: '等线'">
            腾讯公司应当依照本协议约定向您提供本服务和售后支持。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">5.2</span>
          <span style="font-family: '等线'">
            腾讯公司仅对本服务本身提供运营维护，您应当保证自身的网络、设备的安全性、稳定性，如发生以下情况，您应及时解决并避免对本服务产生影响：
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">5.2.1</span>
          <span style="font-family: '等线'">您内部网络出现问题，包括但不限于超负荷等。</span>
          <br />
          <span style="font-family: '等线'">5.2.2</span>
          <span style="font-family: '等线'">您自有设备或您使用的第三方设备出现故障。</span>
          <br />
          <span style="font-family: '等线'">5.2.3</span>
          <span style="font-family: '等线'">您自行拆离设备或通过其他方式导致网络中断。</span>
          <br />
          <span style="font-family: '等线'">5.2.4</span>
          <span style="font-family: '等线'">其他您的原因导致的任何故障、网络中断等。</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">5.3</span>
          <span style="font-family: '等线'">
            若腾讯公司自行发现或根据主管部门的信息、权利人的投诉等发现，您违反相关法律法规、规章制度或本协议的，腾讯公司有权根据自己的独立判断单方采取以下措施中的一种或多种：
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">5.3.1</span>
          <span style="font-family: '等线'">要求您立即删除、修改相关内容。</span>
          <br />
          <span style="font-family: '等线'">5.3.2</span>
          <span style="font-family: '等线'">直接删除、屏蔽相关内容或断开链接等。</span>
          <br />
          <span style="font-family: '等线'">5.3.3</span>
          <span style="font-family: '等线'">
            限制、暂停向您提供本服务（包括但不限于直接对您的部分服务进行下线并收回相关资源、对您本服务帐户进行操作限制等）。
          </span>
          <br />
          <span style="font-family: '等线'">5.3.4</span>
          <span style="font-family: '等线'">
            情节严重的，腾讯公司有权终止向您提供本服务，终止协议（包括但不限于直接对您的全部服务进行下线并收回相关资源等），您未使用的服务期限对应的费用将作为违约金归腾讯公司所有。
          </span>
          <br />
          <span style="font-family: '等线'">5.3.5</span>
          <span style="font-family: '等线'">依法追究您的其他责任。</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">5.4</span>
          <span style="font-family: '等线'">
            腾讯公司如发现您通过本服务分析不符合本服务要求的数据，有权立即停
          </span>
          <span style="font-family: '等线'">
            止相关服务，并删除其中不符合要求的数据，由此给您造成的一切影响，由您自行承担。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">5.5</span>
          <span style="font-family: '等线'">
            腾讯公司可将本协议部分或全部权利义务转让予第三方，但腾讯公司须提前书面通知您。为本款生效之需要，双方同意签订所有合理必要的文件及采取合理必要的措施。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">&#xa0;</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 22pt;
          "
        >
          <span style="font-family: '等线'">第六条</span>
          <span style="font-family: '等线'" />
          <span style="font-family: '等线'">知识产权、保密</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">6.1</span>
          <span style="font-family: '等线'">
            双方单独享有的商标权、著作权或者其他知识产权，均仍归各方单独享有，并不会因为双方签订或者履行本协议而转归对方享有，或者转归双方共同享有。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">6.2</span>
          <span style="font-family: '等线'">
            任何一方均应尊重相对方、第三方的知识产权，如有任何第三方就一方侵犯其知识产权等合法权益的原因向另一方提起诉讼、主张索赔的，责任方应当独立处理相关纠纷，赔偿另一方的直接经济损失，并使另一方完全免责。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">6.3</span>
          <span style="font-family: '等线'">
            任何一方（接收方）从另一方（披露方）所接受之信息，如有标明或可合理认知为属于披露方的机密或专有信息的
          </span>
          <span style="font-family: '等线'">(</span>
          <span style="font-family: '等线'">以下称“保密信息”</span>
          <span style="font-family: '等线'">)</span>
          <span>
            <span style="font-family: '等线'">
              ，接收方须对披露方的保密信息保密，且未经披露方书面同意，不得用于本协议以外目的。接收方应以对待其自身保密信息相同的注意程度（且不得低于合理审慎义务）处理披露方的保密信息。
            </span>
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">6.4</span>
          <span style="font-family: '等线'">
            腾讯公司可以在事先获得您授权的前提下，访问您的存储内容，以便您顺利使用本服务。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">6.5</span>
          <span style="font-family: '等线'">
            尽管如上所述，遇下列情况，接收方无需承担保密义务：
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">6.6.1</span>
          <span style="font-family: '等线'">经披露方同意披露的。</span>
          <br />
          <span style="font-family: '等线'">6.6.2</span>
          <span style="font-family: '等线'">非因接收方的过失而导致众所周知。</span>
          <br />
          <span style="font-family: '等线'">6.6.3</span>
          <span style="font-family: '等线'">
            接收方在披露方披露之前已由其他合法渠道获知，且披露方无类似保密限制的。
          </span>
          <br />
          <span style="font-family: '等线'">6.6.4</span>
          <span style="font-family: '等线'">
            接收方因法律程序或主管机关的要求需要披露任何信息的。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">6.7</span>
          <span style="font-family: '等线'">
            双方保密义务在本协议有效期限内及期限届满后持续有效，直至相关信息不再具有保密意义。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">6.8</span>
          <span style="font-family: '等线'">
            腾讯公司有权根据国家司法、行政等主管部门的要求，配合查询、提供您信息等，以便及时解决投诉纠纷，保护各方合法权益。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">6.9</span>
          <span style="font-family: '等线'">
            为合理保护您、您的用户及权利人等各方的利益，腾讯公司有权制定专门的侵权、投诉流程制度，您应当予以遵守。如果腾讯公司接到第三方对您的投诉或举报，腾讯公司有权向投诉方披露您的必要信息（包括但不限于注册名称、身份证明、联系人、联系电话等），并督促您与投诉方进行协商，以便及时解决投诉、纠纷，保护各方合法权益，您应当予以配合，否则，将可能影响您继续使用本服务服务。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">&#xa0;</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 22pt;
          "
        >
          <span style="font-family: '等线'">第七条</span>
          <span style="font-family: '等线'" />
          <span style="font-family: '等线'">责任限制</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">7.1</span>
          <span style="font-family: '等线'">
            您理解并同意，在使用本服务的过程中可能会遇到以下情况使服务发生中断。出现下述情况时，腾讯公司应及时与相关单位配合进行修复，但是由此给您造成的损失腾讯公司将予以免责。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">7.1.1</span>
          <span style="font-family: '等线'">
            不可抗力，包括但不限于自然灾害、政府行为、政策颁布调整、法律法规
          </span>
          <span style="font-family: '等线'">颁布调整、罢工、动乱。</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">7.1.2</span>
          <span style="font-family: '等线'">
            基础运营商原因，包括但不限于电信部门技术调整、电信
          </span>
          <span style="font-family: '等线'">/</span>
          <span style="font-family: '等线'">电力线路被他人破坏、电信</span>
          <span style="font-family: '等线'">/</span>
          <span style="font-family: '等线'">电力部门对电信网络</span>
          <span style="font-family: '等线'">/</span>
          <span style="font-family: '等线'">电力资源进行安装、改造、维护。</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">7.1.3</span>
          <span style="font-family: '等线'">
            网络安全事故，如计算机病毒、木马或其他恶意程序、黑客攻击的破坏。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">7.1.4</span>
          <span style="font-family: '等线'">
            您通过非腾讯公司授权的方式使用本服务，您操作不当或您的电脑软件、系统、硬件和通信线路出现故障。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">7.1.5</span>
          <span style="font-family: '等线'">
            其他非腾讯公司过错、腾讯公司无法控制或合理预见的情形。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">7.2</span>
          <span style="font-family: '等线'">
            因不可抗力、基础运营商原因、网络安全事故或其他超出当事人可合理掌控范围的事件，造成本协议迟延履行或任何一方违约，双方均无需承担违约责任。但是，受影响一方应尽可能及时通知另一方。如前述事件妨碍协议履行达
          </span>
          <span style="font-family: '等线'">30</span>
          <span style="font-family: '等线'">个自然日以上的，任一方可提前</span>
          <span style="font-family: '等线'">15</span>
          <span>
            <span style="font-family: '等线'">
              天书面通知对方终止协议。因本条款终止协议的，任何一方均无须承担违约责任。
            </span>
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">7.3</span>
          <span style="font-family: '等线'">
            您理解并同意，腾讯公司的服务是按照现有技术和条件所能达到的现状提供的。腾讯公司将尽最大努力确保服务的连贯性和安全性，但腾讯公司不能保证其所提供的服务毫无瑕疵。所以您也同意，即使腾讯公司提供的服务存在瑕疵，但若上述瑕疵是当时行业技术水平所无法避免的，其将不被视为腾讯公司违约，双方应友好协作共同解决问题。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">7.4</span>
          <span style="font-family: '等线'">
            除非本协议有特别约定或您所在的单位与腾讯公司另行约定外，在任何情况下，任何一方均不对相对方任何间接性、偶然性、特殊性的损害和损失，包括但不限于可得利益损失、相对方向第三方支付的费用等承担责任（即使该方已经被告知该等损失的可能性）。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">7.5</span>
          <span style="font-family: '等线'">
            本服务如提供任何数据分析、智能建议等服务，该服务仅用于您及您所在单位日常经营管理决策时参考使用，不能代替您及您所在单位的决策意见。腾讯公司不承诺本服务所给出的数据分析结果或建议的准确性、适用性，您应结合具体情况自行判断。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">&#xa0;</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 22pt;
          "
        >
          <span style="font-family: '等线'">第八条</span>
          <span style="font-family: '等线'" />
          <span style="font-family: '等线'">通知和送达</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">8.1</span>
          <span style="font-family: '等线'">
            您应当保证和维持资料的有效性，您的资料若存在虚假、无效等任何可能导致您无法及时获取业务通知、客户服务、投诉处理、纠纷协调、技术支持等情况的，由您自行承担相应责任。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">8.2</span>
          <span style="font-family: '等线'">
            您应当根据本服务官网公布的腾讯公司的联系方式向腾讯公司发送通知，双方另有约定除外。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">8.3</span>
          <span style="font-family: '等线'">
            腾讯公司可以不定期以网页公告、电子邮件、手机短信、站内信、即时通讯工具等方式中的
          </span>
          <span style="font-family: '等线'">1</span>
          <span>
            <span style="font-family: '等线'">
              种或多种向您发送与本服务有关的业务通知、服务提示、验证消息等各种业务通知，以及营销广告。
            </span>
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">8.4</span>
          <span style="font-family: '等线'">
            各方均应保证其联系方式真实、有效，通知自发送之日视为已送达收件人。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">&#xa0;</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 22pt;
          "
        >
          <span style="font-family: '等线'">第九条</span>
          <span style="font-family: '等线'" />
          <span style="font-family: '等线'">期限</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">9.1</span>
          <span style="font-family: '等线'">
            你有权使用本服务的期限将以您所在单位与腾讯公司签署的
          </span>
          <span style="font-family: '等线'">商务合同</span>
          <span style="font-family: '等线'">约定为准，或由您所在单位的权限管理员管理。</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">9.2</span>
          <span style="font-family: '等线'">
            本协议的到期或终止，不影响协议到期或终止前产生的权利义务。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">&#xa0;</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 22pt;
          "
        >
          <span style="font-family: '等线'">第十条</span>
          <span style="font-family: '等线'" />
          <span style="font-family: '等线'">附则</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">10.1</span>
          <span style="font-family: '等线'">本协议的签订地为广东省深圳市南山区。</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">10.2</span>
          <span style="font-family: '等线'">
            本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">10.3</span>
          <span style="font-family: '等线'">
            因本协议产生之争议，双方应首先协商解决；双方未能以诚意协商解决的，任何一方均应将纠纷或争议提交深圳市南山区人民法院管辖。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">10.4</span>
          <span style="font-family: '等线'">
            本协议的拟定、解释均以中文为准。除双方另有约定外，任何有关本协议的翻译不得作为解释本协议或判定双方当事人意图之依据。
          </span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">&#xa0;</span>
        </p>
        <p
          style="
            margin-top: 6pt;
            margin-bottom: 6pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '等线'">腾讯公司</span>
        </p>
      </div>
    </body>
  </html>
</template>
<script>
export default {};
</script>
<style scoped lang="scss"></style>
